module.exports = __webpack_public_path__ + "img/septima.6925c68e.png";